import React from 'react';
import { Badge, qualityStatusVariant } from '../shared/Badge';
import './QualityHealth.css';

interface Indicator {
  label: string;
  value: string;
  tooltip?: string;
}

interface Props {
  status?: string;
  reason?: string;
  indicators: Indicator[];
  loading?: boolean;
}

const STATUS_COLORS: Record<string, string> = {
  Healthy: '#16a34a',
  Attention: '#d97706',
  'At Risk': '#dc2626',
  Critical: '#dc2626',
  Unknown: '#9099a8',
};

export const QualityHealth: React.FC<Props> = ({ status, reason, indicators, loading }) => {
  const color = STATUS_COLORS[status || 'Unknown'];

  return (
    <div className="qh-card" style={{ borderLeftColor: color }}>
      {loading ? (
        <div className="qh-skeleton" />
      ) : (
        <>
          <div className="qh-top">
            <div className="qh-status-row">
              <span
                className="qh-eyebrow"
                title="Overall status computed from Pass Rate, Critical Failures, and Blocked % this period — whichever indicator is worst decides the status."
              >
                Quality Health
              </span>
              <Badge variant={qualityStatusVariant(status || 'Unknown')} dot>{status || 'Unknown'}</Badge>
            </div>
            <p className="qh-reason">{reason}</p>
          </div>
          <div className="qh-indicators">
            {indicators.map(ind => (
              <div key={ind.label} className="qh-indicator" title={ind.tooltip}>
                <span className="qh-indicator-value">{ind.value}</span>
                <span className="qh-indicator-label">{ind.label}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default QualityHealth;
